'use strict';

const appendListMethod = require('../appendListMethod');

const KEYS = {
  COUNTRY: 'country',
  CITY: 'city',
  BIRTHDAY: 'birthday',
  GENDER: 'gender',
  LANGUAGE: 'language',
  GROUP: 'group',
};

const TYPES = {
  VALUES: 'values',
  RANGE: 'range',
};

const OPERATORS = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
};

const KEY_TYPES = {
  [KEYS.COUNTRY]: TYPES.VALUES,
  [KEYS.CITY]: TYPES.VALUES,
  [KEYS.BIRTHDAY]: TYPES.RANGE,
  [KEYS.GENDER]: TYPES.VALUES,
  [KEYS.LANGUAGE]: TYPES.VALUES,
  [KEYS.GROUP]: TYPES.VALUES,
};

module.exports = {
  AVAILABLE_KEYS: appendListMethod(KEYS).list(),
  KEYS,
  KEY_TYPES,
  AVAILABLE_TYPES: appendListMethod(TYPES).list(),
  TYPES,
  AVAILABLE_OPERATORS: appendListMethod(OPERATORS).list(),
  OPERATORS,
};
